import { Filter } from '../filter';
import { ErrorType, FieldValues, NumberComparisonErrorCodes } from '../types';

export abstract class NumberCompareFilter implements Filter<number> {
    protected constructor(
        protected readonly errorCode: NumberComparisonErrorCodes,
        protected otherFieldName: string,
    ) {}

    async validate(fieldValue: number, otherFields: FieldValues): Promise<Array<ErrorType>> {
        const otherFieldValue = otherFields[this.otherFieldName];
        if (otherFieldValue === undefined) {
            return [];
        }
        if (typeof otherFieldValue != 'number') {
            // As we can't return errors for other fields than the one that we are currently
            // validating here, we need to raise this error.
            // If we raise this error, it could be for two reasons:
            //   - the other field is not in the expected type: in this case we will have another
            //     error with code invalidType for this other field;
            //   - the other field is not the one attended: it's a mistake in the configuration! It
            //     should never happen if tests are executed;
            //   - in case the other field is optional and not given, we return no error has checked
            //     on top of this function.
            return [
                {
                    code: this.errorCode,
                    otherFieldName: this.otherFieldName,
                    otherFieldValue,
                },
            ];
        }

        return this.compare(fieldValue, otherFieldValue);
    }

    abstract compare(fieldValue: number, otherFieldValue: number): Array<ErrorType>;
}
